<template>
  <div class="background-image min-h-100">
    <form @submit.prevent="submitResponse" id="qvctForm">
      <div class="container image-border-bottom container-survey sticky-header border border-1 shadow rounded-bottom bg-white min-h-50px px-10 py-3 d-flex align-items-center justify-content-between z-index-3">
        <a class="">
          <Img alt="Logo" filename="logo.png" class="h-30px"/>
        </a>
      </div>
      <div class="container container-survey py-10 h-100">
        <div class="card shadow-sm mb-7">
          <div class="card-body">
            <section style="padding: 2rem; border-radius: 8px; text-align: center; font-family: Arial, sans-serif;">
              <h2 class="fw-bold fs-3x">🙏 Merci pour votre participation</h2>
              <p class="fs-2 fw-normal" style="max-width: 600px; margin: 1rem auto;">
                Nous vous remercions sincèrement d’avoir pris le temps de répondre à ce questionnaire.
              </p>
              <p class="fs-3 fw-normal" style="max-width: 600px; margin: 1rem auto;">
                Votre contribution est précieuse. Elle nous permettra d’identifier des pistes d’amélioration concrètes pour favoriser un environnement de travail plus sain, collaboratif et épanouissant pour toutes et tous.
              </p>
              <p class="fs-4 fw-normal" style="color: #888; font-size: 0.9rem; max-width: 600px; margin: 1rem auto;">
                Vos réponses sont anonymes et traitées avec la plus grande confidentialité.
              </p>
            </section>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script setup>
import Img from "@/components/Img.vue"
</script>
<style scoped>
.background-image {
  background:
      linear-gradient(rgba(0, 114, 206, 0.1), rgba(240, 120, 23, 0.1)),
      url('../../../../../public/assets/media/empty_bg.png') no-repeat center center,
      url('../../../../../public/assets/media/empty_bg.png') no-repeat center center;
  background-size: cover, cover, cover;
  width: 100%;
}

.image-border-bottom {
  border-bottom: 13px solid transparent !important;
  border-image: url('../../../../../public/assets/media/qvct_servey-banner.png') 30 round !important;
  border-image-slice: 0 0 56 0 !important;
  border-image-width: 0 0 13px 0 !important;
  border-image-outset: 0 !important;
}

.image-border-top {
  border-top: 13px solid transparent !important;
  border-image: url('../../../../../public/assets/media/qvct_servey-banner.png') 30 round !important;
  border-image-slice: 56 0 0 0 !important;
  border-image-width: 13px 0 0 0 !important;
  border-image-outset: 0 !important;
}

.sticky-header {
  position: sticky;
  top: 0;
  z-index: 1030;
}

.sticky-footer {
  position: sticky;
  bottom: 0;
  z-index: 1030;
}

.container-survey {
  margin: auto;
  max-width: 90vw;
  width: 640px;
}

.powered-by a {
  color: #007BFF;
  text-decoration: none;
  font-weight: 500;
}

.powered-by a:hover {
  text-decoration: underline;
}

</style>